import React, {useContext, useEffect, useState} from 'react';
import ReactSelect from "react-select";

import * as ApiCalls from "../ApiCalls.js";

import {azureTokenContext, userIdContext, userInfoContext} from "../../../App.tsx";
import {targetUserIdContext} from "../../MainPart.tsx";

export default function SelectTargetUser() {
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);
    const [allUsersOptions, setAllUsersOptions] = useState<[]>([]);
    const [userInfo] = useContext(userInfoContext);
    const [targetUserId, setTargetUserId] = useContext(targetUserIdContext);
    const [allUsersLoaded, setAllUsersLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (userInfo?.IsKarnovEmployee) {
            // setAllUsers([]);
            ApiCalls.getAllUsers(azureToken)
                .then((res) => {
                    const sortedUsers = res.sort((a, b) => a.Name.localeCompare(b.Name));
                    // setAllUsers(sortedUsers);
                    setAllUsersOptions(
                        sortedUsers.map((user) => ({
                            value: user.Id,
                            label: user.Name,
                        }))
                    );
                    setAllUsersLoaded(true);
                })
                .catch((err) => {
                    console.error("Get All Users fail", err);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const handleViewDropdownChange = (option: any) => {
        setTargetUserId(option.value);
    };

    const hideAsUserBox = () => {
        document.getElementsByClassName("user-select-container")[0].setAttribute("style", "display: none");
    }

    return (
        <div className="user-select-container mt-1">
            {userInfo?.IsKarnovEmployee && allUsersLoaded && (
                <div className="user-select-dropdown">
                    <label htmlFor="user-select">Ser som:</label>
                    <ReactSelect
                        id="user-select"
                        value={allUsersOptions.find((option: any) => option.value === targetUserId)}
                        onChange={(selectedOption) => handleViewDropdownChange(selectedOption)}
                        options={allUsersOptions}
                        isSearchable
                        placeholder="Velg person"
                        className="custom-select"
                    />
                    <button style={{"marginLeft": "14px"}} onClick={hideAsUserBox}>X</button>
                </div>
            )}
        </div>
    )
}